import { useFeatureContext } from '../contexts/FeatureContext';

/**
 * Returns { enabled: boolean, loading: boolean } for a given feature key.
 *
 * Usage:
 *   const { enabled, loading } = useFeature('assessments_mode');
 */
export function useFeature(featureKey) {
  const { features } = useFeatureContext();

  if (features === null) {
    return { enabled: false, loading: true };
  }

  return {
    enabled: features[featureKey]?.enabled ?? false,
    loading: false,
  };
}
